import {createStore} from 'vuex';
import usb from './modules/usb/index.js';
import {headerfooter} from 'vue3-header-footer';
import { livechat } from "vue3-live-chat";


const store = createStore({
  modules:{
    usb,
    headerfooter,
    livechat
  }
});

export default store;